//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFileRemoveFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M14 2V8H20V22H4V2H14ZM8 15H16V13H8V15ZM15.5 6.50003V2.09003L19.91 6.50003H15.5Z" fill="currentColor" /></svg>;
}
export default IconFileRemoveFill;